export default __webpack_public_path__ + "studenten-blue-6986463f54d3f46d2bc78e0e8f8f9dd4.bundle.svg";